// src/config/config.js

const ENV = process.env.REACT_APP_ENV;

const config = {
    env: ENV,
    apiUrl1: ENV === 'prod' ? 'https://api1.roadassist.uz' : 'http://localhost:8081',
    apiUrl2: ENV === 'prod' ? 'https://api2.roadassist.uz' : 'http://localhost:8083',
};

export default config;
